.menu {
  width: 100%;

  border-left: none;
  border-right: none;
  text-align: center;
  padding-top: 0;
  padding-bottom: 0;

  background-color: var(--bg-color);
  border-color: var(--main-color);
  color: var(--main-color);

  &::backdrop {
    background: none;
    backdrop-filter: blur(2px);
  }

  & > section {
    margin: 32px auto 40px;
    gap: 32px;
    max-width: 270px;
    display: flex;
    flex-direction: column;
  }

  .navigation {
    color: var(--accent-color);
  }

  .appearance {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  select,
  button {
    width: 100%;
  }
}
